export default __webpack_public_path__ + "static/media/AboutVideo.13b87a74.mp4";